/* eslint-disable */
const hash = {
  "en-US": "9e4587c0",
  "de-DE": "dd25d222",
  "es-ES": "fc474dab",
  "fr-FR": "95ee2a9b",
  "id-ID": "e17f8fc0",
  "it-IT": "8dc23739",
  "jp-JP": "d6aa7db5",
  "ko-KO": "4d853b50",
  "nl-NL": "d957cabd",
  "pl-PL": "41696cbf",
  "pt-PT": "d43eb038",
  "ru-RU": "aefe08ea",
  "tr-TR": "2f64f432",
  "vi-VN": "a22c6438",
  "zh-CN": "4189fd6e",
  "zh-TW": "4beb1d7b",
  "sv-SE": "a85fcc8b",
  "control": "88720108",
  "plan-details": "e8333e2a",
  "gov-EN": "db4f8a43",
  "en-GB": "687e0573"
}
export default hash
